import React from 'react';
import styled from 'styled-components';

const ImageModalContainer = styled.div`
  /* The Modal (background) */
  &.modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 10; /* Sit on top */
    // padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
  }

  &.modal-inline-images {
    z-index: 100;
  }

  /* Modal Content (image) */
  .modal-content {
    margin: auto;
    display: block;
    // width: 100%;
    max-width: 90vw;
  }

  @-webkit-keyframes zoom {
    from {
      -webkit-transform: scale(0);
    }
    to {
      -webkit-transform: scale(1);
    }
  }

  @keyframes zoom {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }

  /* The Close Button */
  .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }

  /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px) {
    .modal-content {
      width: 100%;
    }
  }
`;

export const ImagePreviewModal = (props) => {
  return (
    <ImageModalContainer id="myModal" className="modal modal-inline-images">
      <span
        className="close"
        onClick={() => {
          document.querySelector('.modal-inline-images').style.display = 'none';
        }}
      >
        &times;
      </span>
      <img className="modal-content modal-content-inline-images" id="img01" />
    </ImageModalContainer>
  );
};
